export default "__VITE_ASSET__2e5c516e__"